import { useAppStore } from "@/stores/appStore";
import DatasEditorServices from "@/services/DatasEditorServices.js";
import wh from "@/helpers/widgetsHelpers.js";

import PagesServices from "@/services/PagesServices";
import { stripHtml } from "@/util/Functions";

export default {


  computed: {
  appStore() {
    return useAppStore();
  },

  activePage() {
    return this.appStore.active.page || {};
  },

  activeWidget() {
    return this.appStore.active.widget || {};
  },

  activeView() {
    return this.appStore.active.view || {};
  },

  appPages() {
    return this.appStore.pages || [];
  },
  },

  methods:{


  
  async actionsTrigger(action, item) {

   const  appStore = useAppStore();
    switch (action) {
      case "go-to-detail-screen":
        await this.navigateToPage({
          item,
          screentype: "single-collection",
          title: item.page_title || "Detailpagina",
          icon: "file-text",
          description: "Autogegenereerde detailpagina van collectie",
          useItemAsDetail: true,
          data: item.data || {},
       
        });
        console.log("action go-to-detail-screen item is:", item);
        console.log("action go-to-detail-screen collecion id is:", item.collection_id);
        break;
  
      case "go-to-edit-screen":
        await this.navigateToPage({
          item,
          screentype: "edit-collection",
          title: `Edit ${item.title || "Item"}`,
          icon: "edit",
          description: "Autogegenereerde editpagina",
          useItemAsDetail: true,
          data: item.data || {},
        });
        break;
  
      case "go-to-profile":
        await this.navigateToPage({
          item,
          screentype: "profile",
          title: "Profiel",
          icon: "user",
          description: "Autogegenereerde profielpagina",
          useItemAsDetail: false,
          data: item.data || {},
        });

        appStore.active_detail_page = appStore.active.user;
        break;

        case "open-url":
          window.open(wh.replaceActionData(item.action.action.url, item), '_blank', 'noopener,noreferrer');
          console.log("action open-url", item);

          break;
    
  
      case "copy-clipboard":
        this.copyToClipboard(item);
        break;
  
      case "add-row":

        this.addCollectionData(item);
        break;
  
      case "edit-row":
        this.updateCollectionData(item);
        break;
  
      case "delete-row":
        console.log("Action delete-row", item);

        this.deleteCollectionData(item);
        break;
  
      case "show-form-screen":
        this.showFormScreen(item);
        break;
  
      case "hide-form-screen":
        this.hideFormScreen();
        break;

        case "show-message":
          console.log("Action show-message", item.data);
        this.$toast.info(wh.replaceActionData(item.message, item) || "No message provided");
        break;
  
      default:
        console.error("Action Unknown:", action);
    }
  },
  

  /**********************************
     * 1. Go to detail screen
     **********************************/
  goBack() {
    const appStore = useAppStore();
  
    // Verwijder de laatste stap (de huidige pagina)
    appStore.popBreadcrumb();
  
    // Pak de vorige stap
    const previous = appStore.breadcrumb[appStore.breadcrumb.length - 1];
  
    if (previous) {
      const page = appStore.pages.find(p => p.id === previous.id);
      if (page) {
        appStore.setActivePage(page);
        appStore.setActiveView(page);
      }
    }
  },

  async navigateToPage({ item, screentype, title, icon, description, useItemAsDetail = false }) {
    const appStore = useAppStore();

    console.log('navtopage',item);

 // 1) bepaal de collectionId uit het item
const collectionId =
item.collection_id ??            // bv. 1
item.collection?.id ??           // fallback op embedded object
item.collection?.collection ??   // fallback op 1e pagina-vorm
null;


const collectionData = appStore.collections.find(
  c => c.id === collectionId
) || null;

// 2) zoek een bestaande pagina
let selectedPage = appStore.pages.find((page) => {
// ­profile-pagina’s hebben géén collectie-vergelijking nodig
// if (page.screentype === "profile" && screentype === "profile") return true;

// detail-pagina’s kunnen 'single-collection' of 'single-detailpage' heten
const isDetail =
  ["single-collection", "single-detailpage"].includes(page.screentype) &&
  ["single-collection", "single-detailpage"].includes(screentype);

// andere types moeten exact matchen
const typeMatch = isDetail || page.screentype === screentype;

console.log('pagecollection',page);
// bij alles behalve profile moet de collectie overeenkomen
const collectionMatch =
  (page.collection?.id ?? page.collection?.collection) === collectionId;

return typeMatch && collectionMatch;
});



    // Maak nieuwe pagina aan indien nodig
    if (!selectedPage) {
      try {
        const createPayload = {
          title: collectionData.name || title,
          screentype,
          app_id: appStore.active.app.id,
          icon: icon || "file",
          collection_id: collectionId,
          widget_style: "custom",
          login_required: false,
          show_in_menu: false,
          hide_menu: false,
          data: [],
          slug: `${screentype}-${collectionId}-${Date.now()}`,
          description: description || `Auto gegenereerde ${screentype} pagina`
        };
  
        const response = await PagesServices.createPage(createPayload);
        if (response.data?.success) {
          selectedPage = response.data.page || response.data.data;
          appStore.pages.push(selectedPage);
        } else {
          console.error("Fout bij aanmaken van pagina:", response.data);
          return;
        }
      } catch (err) {
        console.error("Fout bij createPage:", err);
        return;
      }
    }
  
    // Voeg breadcrumb toe
    if (appStore.active.page?.id) {
      appStore.addBreadcrumb({
        name: appStore.active.page.title,
        id: appStore.active.page.id,
        slug: appStore.active.page.slug,
      });
    }
  
    appStore.addBreadcrumb({
      name: wh.replaceFieldToData(item, "title", this.data) || title,
      id: selectedPage.id,
      slug: selectedPage.slug,
      collection_id: selectedPage.collection.id,
      item_id: item.id,
    });
  
    // Zet actieve pagina + context
    if (screentype === 'profile') {
      appStore.active_detail_page = item;
      appStore.setActiveView(selectedPage);
    } else {
      appStore.setActivePage({
        ...selectedPage,
        ...(useItemAsDetail ? { detail_page: { ...item } } : {})
      });
    
      appStore.setActiveView(selectedPage);
    }
    
  
    if (screentype === "edit-collection") {
      appStore.setActiveEditpage({
        ...selectedPage,
        detail_page: { ...item },
      });
      appStore.setActiveView(item);
    } else {
      appStore.setSelectedItem(item);
      appStore.setActiveView(selectedPage);
    }
  },
  
  
  /**********************************
         * 2. Go to detail screen
         **********************************/

  

  async addCollectionData(item) {
    const appStore = useAppStore();
console.log('items',item);

    if (!item?.action?.collection?.id) {
      alert("Collection ID is required to add data.");
      return;
    }
    this.loading = true;

    try {
      const response = await DatasEditorServices.createData(
        item.action.collection.id,
        item.widget.data
      );

      if(response.data ) {
     
      appStore.data = [
        ...appStore.data,
        response.data.data
      ];

      this.isEdit = false;
      this.loading = false;
      this.openEditCreateDialog = false;
      console.log("item", item);
      this.$toast.success( stripHtml(item.message) || "Data successfully added!");  
    }
    } catch (error) {
      console.log(error);
      this.$toast.error(error.response?.data?.message || "Er is een fout opgetreden bij het toevoegen van de data.");
    } finally{
      this.loading = false;
    }
  },

  async updateCollectionData(item) {


    if (!item.data.collection.id) {
      return;
    }
    this.loading = true;

    try {
      const response = await DatasEditorServices.updateData(item.data);

      if (response.data) {
        this.collection_data = this.collection_data.map(
          data => (data.id === item.id ? response.data.data : data)
        );
      }
      this.isEdit = false;
      this.loading = false;
      this.openEditCreateDialog = false;
      this.$toast.success("Data successfully updated!");
    } catch (error) {
      this.$toast.error(error.response?.data?.message || "Er is een fout opgetreden bij het toevoegen van de data.");
    }
  },

  async deleteCollectionData(item) {
    console.log('deleteCollectionData called with item:', item);
    try {
      const response = await DatasEditorServices.deleteData(item.id, this.rawCollectionId);
      if (response?.data?.success) {
        this.$toast.success(response.data.message || "Verwijderen gelukt");
      } else {
        this.$toast.error(response?.data?.message || "Verwijderen mislukt");
      }
      await this.fetchCollectionData();
    } catch (err) {
      console.error("Verwijderfout:", err);
      this.$toast.error("Fout bij verwijderen van item.");
    }
  },

  showFormScreen(item) {

    console.log("showFormScreen called with item:", item);

    const appStore = useAppStore();
    console.log("page id", item.action.page);
    const selectedPage = appStore.pages.find(
      page => item.action.page === page.id
    );

    
    console.log("sel formpage", selectedPage);

    if (selectedPage) {
      appStore.setSelectedItem(item);
      appStore.setActiveFormScreen(selectedPage);
      appStore.setActiveView(selectedPage);


 
    } else {
      console.error(
        "Geen pagina gevonden voor de opgegeven collection en screentype"
      );
    }
  },

  hideFormScreen() {
    const appStore = useAppStore();

    appStore.show_active_form_screen = false;
    appStore.active.form_screen = {};
  },

  copyToClipboard(item) {
    const textToCopy = item.action.data;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log("Text copied to clipboard:", textToCopy);
      })
      .catch(err => {
        console.error("Failed to copy text: ", err);
      });
  },


  }
  
};
